import { baseTopColors, colorShades, fontWeightsMap, textSizesMap } from "../theme";

export const StorybookFullColorPicker = {
	control: { type: "select" },
	options: [...colorShades],
} as const;

export const StorybookFullTextSizePicker = {
	control: { type: "select" },
	options: [...Object.keys(textSizesMap)],
} as const;

export const StorybookFullTextWeightPicker = {
	control: { type: "select" },
	options: [...Object.keys(fontWeightsMap)],
} as const;

export const StorybookBaseColorPicker = {
	control: { type: "select" },
	options: [...baseTopColors],
} as const;
